<template>
  <template v-for="(post, i) in posts" :key="i">
    <div class="card card--portfolio" :class="[props.class]">
      <div class="card__image">
        <Swiper class="swiper swiper--portfolio" :modules="[SwiperAutoplay, SwiperEffectFade]" :slides-per-view="1"
          :loop="true" :allow-touch-move="false" :effect="'fade'" :autoplay="{
            delay: 1000,
            disableOnInteraction: false,
          }" :dots="true" :speed="2500" :creative-effect="{
            prev: {
              shadow: false,
              translate: ['-20%', 0, -1],
            },
            next: {
              translate: ['100%', 0, 0],
            },
          }">
          <template v-if="post?.portfolios && post.portfolios.length">
            <!-- Our Service -->
            <template v-if="category">
              <SwiperSlide v-for="(portfolio, j) in getPortfolio(
                post.portfolios,
                category
              )" :key="j">
                <a :href="portfolio.url" target="_blank">
                  <img :src="portfolio.image" :alt="portfolio.name" />
                </a>
              </SwiperSlide>
            </template>

            <!-- Our Portfolios -->
            <template v-else>
              <SwiperSlide>
                <a :href="post.url" target="_blank">
                  <img :src="post.image" :alt="post.name" />
                </a>
              </SwiperSlide>
            </template>
          </template>

          <template v-else>
            <!-- Default -->
            <SwiperSlide>
              <a :href="post.url" target="_blank">
                <img :src="post.image" :alt="post.name" />
              </a>
            </SwiperSlide>
          </template>
        </Swiper>
        <div class="card__btn">
          <div class="card__icon">
            <i class="icon-arrow-button"></i>
          </div>
        </div>
      </div>

      <div class="card__body">
        <div class="card__title">{{ post.title }}</div>
        <div class="card__subtitle">{{ post.excerpt }}</div>
      </div>

      <div class="card__wrapper" v-if="(showTags != 'false') && post.categories && post.categories.length">
        <template v-for="(tag, tagIdx) in post.categories" :key="tagIdx">
          <a :href="`/en/our-product-and-service/${tag.slug}`" v-if="tag.name != 'Highlight' && tag.name != 'Our Portfolio'">
            <div class="card__tag"><i class="icon-tag"></i> {{ tag.name }}</div>
          </a>
        </template>
      </div>
    </div>
  </template>


</template>

<script setup>
// รับ props
const props = defineProps({
  class: String,
  posts: {
    type: Object,
    required: true,
  },
  category: {
    type: String,
    required: false,
  },
  showTags: {
    type: Boolean,
    default: true, // ค่าเริ่มต้นเป็น true
  },
  isHome: {
    type: Boolean,
    default: false, // ค่าเริ่มต้นเป็น false
  },
  isAll: {
    type: Boolean,
    default: false, // ค่าเริ่มต้นเป็น false
  },
});

const getPortfolio = (portfolios, category) => {
  return portfolios.filter((portfolio) => portfolio.name === category);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .card {
      &.card--portfolio {
        .card__title {
          @include font-size("lead", $lang);
          @include font-weight("semibold", $lang);
        }

        .card__subtitle {
          @include font-size("small", $lang);
        }

        .card__tag {
          @include font-size("small", $lang);
        }
      }
    }
  }
}

.card {
  border-radius: 0;
  border: 0;

  &.card--portfolio-homepage {
    .card__title {
      color: $white;
    }

    .card__subtitle {
      color: $white;
    }
  }

  &.card--portfolio {
    margin-bottom: 30px;
    background-color: transparent;
    @include transition;

    @include media-breakpoint-down(md) {
      margin-bottom: 2.5rem;
    }

    &:nth-child(even) {
      margin-top: 60px;

      @include media-breakpoint-down(md) {
        margin-top: 0px;
      }
    }

    .card__image {
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
        @include transition;
      }
    }

    .card__body {
      padding: 1rem 1.25rem;
    }

    .card__btn {
      position: absolute;
      right: 10%;
      bottom: 16%;
      z-index: 1;
      @include transition;
    }

    .card__icon {
      position: relative;
      width: 140px;
      height: 140px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      @include transition;

      i {
        position: relative;
        opacity: 0;
        transform-origin: center;
        font-weight: 500;
        font-size: px-to-rem(40);
        @include transition;
        z-index: 1;
      }

      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-radius: 50%;
        background-color: $white;
        @include transition;
      }

      @include media-breakpoint-down(lg) {
        width: 100px;
        height: 100px;

        i {
          font-size: px-to-rem(30);
        }
      }

      @include media-breakpoint-down(md) {
        width: 70px;
        height: 70px;

        i {
          font-size: px-to-rem(24);
        }
      }
    }

    .card__wrapper {
      display: flex;
      align-items: flex-start;
      align-content: flex-start;
      align-self: stretch;
      gap: 10px;
      flex-wrap: wrap;
    }

    .card__tag {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      padding: 0.5rem 0.75rem;
      background: rgba($black, 0.1);
      backdrop-filter: blur(5px);
      border-radius: 25px;
      color: $black;

      i {
        font-size: px-to-rem(20);
      }
    }

    @include hover {
      .card__image {
        img {
          transform: scale(1.075);
        }
      }

      .card__icon {
        &::after {
          width: 100%;
          height: 100%;
        }

        i {
          opacity: 1;
        }
      }
    }

    &.our-portfolio {
      // margin-bottom: 40px;

      &:nth-child(even) {
        margin-top: 60px;

        @include media-breakpoint-down(md) {
          margin-bottom: 60px;
        }
      }

      &:nth-child(2n + 1) {
        margin-bottom: 120px;

        @include media-breakpoint-down(md) {
          margin-bottom: 0px;
        }
      }

      .card__image {
        img {
          height: 377px;
        }
      }

      .card__title {
        color: $black;
      }

      .card__subtitle {
        color: $black;
      }
    }

    &.our-service {
      margin-bottom: 2.5rem;

      &:nth-child(even) {
        margin-top: 0;
      }

      .card__title {
        color: $black;
      }

      .card__subtitle {
        color: $black;
      }

      .card__image {
        img {
          min-height: 400px;
        }
      }

      .card__icon {
        width: 108px;
        height: 108px;

        i {
          font-size: px-to-rem(32);
        }
      }
    }
  }
}
</style>